/**
 * 反馈
 */
import './index.less';

export default function Feedback() {
  return <a className="feedback-warp" href="https://docs.qq.com/form/page/DR2JzY25va3dGbWpM" target="_blank">反馈</a>
}